import React from "react";
import { cn } from "../../../common/u1/cn";
import {
  CheckCircleIcon,
  AlertIcon,
  InfoIcon,
} from "../../../../assets/ui/icons";

/* The approval state of one section. */
const STATES = {
  Verified: {
    label: "Verified",
    Icon: CheckCircleIcon,
    tone: "border-[var(--verified-border)] bg-[var(--success-soft)] text-[var(--success)]",
  },
  Declined: {
    label: "Declined",
    Icon: AlertIcon,
    tone: "border-[var(--coral)] bg-[var(--coral-soft)] text-[var(--coral-deep)]",
  },
  Skipped: {
    label: "Skipped",
    Icon: InfoIcon,
    tone: "border-[var(--line)] bg-[var(--slate-2)] text-[var(--muted)]",
  },
};

export const SectionStatusPill = ({
  status,
  /* Per-section wording for a state, keyed by status — License Information
     says "Verified by TREVEX" rather than a bare "Verified", because there the
     point is WHO verified it. The state's tone and icon are unchanged. */
  labels,
  className = "",
}) => {
  const state = STATES[status];
  if (!state) return null;
  const { Icon } = state;
  const label = labels?.[status] || state.label;

  return (
    <span
      className={cn(
        /* `whitespace-nowrap`: the tick and the label are one badge, and a narrow column must not break "Verified by TREVEX" underneath its own tick. */
        "inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1",
        "text-[11px] font-bold uppercase tracking-[0.05em] font-sans",
        state.tone,
        className
      )}
    >
      <Icon size={11} />
      {label}
    </span>
  );
};

export default SectionStatusPill;
